module.exports = __webpack_public_path__ + "static/media/jumper_jeff.2a491bf3.jpg";